import Alert from '@/components/UI/alert/Alert';
import { FC } from 'react';
interface DatePickerDescriptionProps {
  discount?: number;
  mid_term_minimum_days?: number;
}
const DatePickerDescription: FC<DatePickerDescriptionProps> = ({
  mid_term_minimum_days = 20
}) => {
  return <Alert title={` برای استفاده از تخفیف رزرو بلندمدت، حداقل ${mid_term_minimum_days} روز را انتخاب کنید.`} type="secondary" icon="info-circle" data-sentry-element="Alert" data-sentry-component="DatePickerDescription" data-sentry-source-file="DatePickerDescription.tsx" />;
};
export default DatePickerDescription;